export default "__VITE_ASSET__CNFpdtUw__"